let treeFactory = require('./tree');
let Filter = require('./filter');
let Controls = require('./controls');
let css = require('./filterable-tree.css');
let { cut } = require('../../../../helpers/utils');
let $ = require('jquery');
let treeSignals = require('../../../../signals/custom-order/filterable-tree');

const LIST_WRAPPER_SELECTOR = cut(css.fieldset);
const LIST_SELECTOR = cut(css.contentTree);
const SCROLLBAR_SELECTOR = cut(css.scrollbar);
const SCROLLTRACK_SELECTOR = cut(css.scrolltrack);

class FilterableTree {
    constructor () {
        this.template = require('./template.hbs');
    }

    bind () {
        this.initBaron();
    }

    /**
     * Инициализация baron
     */
    initBaron () {
        let isInit = false;
        let baron = require('baron');
        let elementId = this.$context.attributes.id;
        let rootSelector = `#${elementId} ${LIST_WRAPPER_SELECTOR}`;

        let root = document.getElementById(elementId);
        if (root) {
            let root1 = root.getElementsByClassName(LIST_WRAPPER_SELECTOR.substring(1))[0];
            if (root1.getAttribute('data-baron-v')) {
                isInit = true;
            }
        }
        if (!isInit) {
            baron({
                root: rootSelector,
                scroller: LIST_SELECTOR,
                bar: SCROLLBAR_SELECTOR,
                track: SCROLLTRACK_SELECTOR,
                $
            });
        }
    }

    render () {
        const props = this.$context.props;
        let isSmallTreeBool = this.$context.props.isSmallTree === 'true';
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css },
            { isSmallTreeBool }, props));
    }
}

module.exports = function ({ basePath, customFilter }) {
    return {
        constructor: FilterableTree,
        children: [
            {
                name: 'tree',
                component: treeFactory(basePath),
                props: {
                    onSubTreeCollapse: treeSignals.onSwitchSubTreeCollapse,
                    basePath: basePath
                },
                parentPropsMap: {
                    onItemCheck: 'onItemCheck',
                    checkboxIdPrefix: 'id',
                    isSmallTree: 'isSmallTree'
                },
                watcher: (attributes) => {
                    let id = attributes['cat-id'];
                    return {
                        item: basePath.concat('computed', 'items', id),
                        expand: basePath.concat('expanded', id),
                        autoExpand: basePath.concat('computed', 'autoExpand'),
                        showDescendantsCount: basePath.concat('computed', 'showDescendantsCount'),
                        isSelected: basePath.concat('selected', id, 'value'),
                        showSelectedOnly: basePath.concat('computed', 'showSelectedOnly')
                    };
                }
            },
            {
                name: 'filter',
                component: Filter,
                props: {
                    onFilter: treeSignals.onFilter,
                    basePath: basePath
                },
                parentPropsMap: {
                    minLength: 'minFilterLength',
                    treeId: 'id'
                },
                watcher: {
                    hideFilter: basePath.concat('hideFilter')
                }
            },
            {
                name: 'controls',
                component: Controls(customFilter),
                props: {
                    onShowSelectedOnly: treeSignals.onShowSelectedOnly,
                    basePath: basePath
                },
                parentPropsMap: {
                    onSetAll: 'onSetAll',
                    treeId: 'id'
                },
                watcher: {
                    showSelectedOnly: basePath.concat('showSelectedOnly')
                }
            }
        ]
    };
};




// WEBPACK FOOTER //
// ./components/common/custom-order/filterable-tree/index.js